import { render, staticRenderFns } from "./tradeDetail.vue?vue&type=template&id=2c2549f0&scoped=true"
import script from "./tradeDetail.vue?vue&type=script&lang=js"
export * from "./tradeDetail.vue?vue&type=script&lang=js"
import style0 from "./tradeDetail.vue?vue&type=style&index=0&id=2c2549f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2549f0",
  null
  
)

export default component.exports